import {HttpClient} from '@angular/common/http';
import {map, shareReplay} from 'rxjs/operators';
import {Observable} from "rxjs";
import {Entity} from "../model/Entity";
import {EntityQuery} from "../interface/EntityQuery";
import {Inject} from "@angular/core";

export class RequestObj {
  data: any
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export interface HttpBaseConfig {
  httpBase: string;
  organizationId: any;
}

export class GeneralService implements EntityQuery{
  serviceName
  httpBase: string;
  organizationId: any;
  modelPath: string;
  fullData$: Observable<any>;
  searchData$: Observable<any>;
  requestData$: Observable<any>;
  cachedFullData$: Observable<any>;
  cacheMap: {[key: string]: Observable<any>} = {};
  businessType;
  lastCacheTime;

  constructor(
    public http: HttpClient,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    if (httpBaseSettings) {
      this.setHttpBase(httpBaseSettings?.httpBase);
      this.setOrganizationId(httpBaseSettings?.organizationId);
    }
  }
  
  setHttpBase(httpBase: string) {
    this.httpBase = httpBase;
  }

  setOrganizationId(organizationId: any) {
    this.organizationId = organizationId;
  }

  setModelPath(modelPath: string) {
    this.modelPath = modelPath;
  }

  setBusinessType(businessType) {
    this.businessType = businessType;
  }

  getServiceName(): string {
    return this.serviceName ? this.serviceName : this.constructor.name;
  }

  getDataCacheStatus(): string {
    return this.cachedFullData$ ? 'ready': 'none';
  }

  getLastCacheTime() {
    return this.lastCacheTime;
  }

  fetchData() {
    this.cachedFullData.subscribe(res => {

    }, error => {
      console.error(this.constructor.name + ' data caching has problem');
    });
  }

  getGeneralQueryData(key, queryUrl, params?) {
    if (!this.cacheMap[key]) {
      this.cacheMap[key] = this.http.get(this.httpBaseSettings?.httpBase + queryUrl, {params}).pipe(map(res => res['data']), shareReplay(1));
    }
    setTimeout(() => {
      this.cacheMap[key] = null;
    }, 10000);
    return this.cacheMap[key];
  }

  get cachedFullData() {
    return this.fetchFullDataToLocal().pipe(map(res => {
      // res.sort((a, b) => b.id - a.id);
      return res;
    }));
  }

   fetchFullDataToLocal() {
    if (!this.cachedFullData$) {
      this.lastCacheTime = new Date().getTime();
      this.cachedFullData$ = this.searchByPage().pipe(map(res => res ? res['data'] : []), shareReplay(1));
    }
    setTimeout(() => {
      this.cachedFullData$ = null;
    }, 10000);
    return this.cachedFullData$;
  }

  searchByPage(pageNumber?: number, pageSize?: number, additionalParams?: any, orderProperty?, orderType?: 'ASC' | 'DESC') {
    return this.queryByPage(pageNumber, pageSize, additionalParams, orderProperty, orderType).pipe(map(res => res['data']));
  }
  
  queryByPage(pageNumber?: number, pageSize?: number, additionalParams?: any, orderProperty?, orderType?: 'ASC' | 'DESC'): Observable<any> {
    const params = {
      pageNumber: pageNumber ? pageNumber.toString() : '1',
      pageSize: pageSize ? pageSize.toString() : '0'
    }
    if (orderProperty) {
      params['orderProperty'] = orderProperty;

      if (orderType) {
        params['orderType'] = orderType;
      }
    }

    if (additionalParams) {
      const keys = Object.keys(additionalParams);
      keys.forEach(key => {
        params[key] =  additionalParams[key];
      })
    }

    return this.http.get(this.httpBase + this.modelPath, {params: params});
  }

  clearCache() {
    this.cachedFullData$ = null;
    this.fullData$ = null;
    this.searchData$ = null;
  }

  request(method, url, params, useCache?): Observable<any> {
    return this.http[method](this.httpBase + url, params).pipe(
      map(res => res['data']),
      shareReplay(1)
    );
  //  if (useCache) {
  //     if (!this.requestData$) {
  //       this.requestData$ = this.http[method](this.httpBase + url, params).pipe(
  //         map(res => res['data']),
  //         shareReplay(1)
  //       );
  //     }
  //     setTimeout(() => {
  //       this.requestData$ = null;
  //     }, 10000);
  //    return this.requestData$;
  //   } else {
  //     return this.http[method](this.httpBase + url, params).pipe(
  //       map(res => res['data']),
  //       shareReplay(1)
  //     );
  //   }
  }

  searchData(params, useCache?: boolean, cacheTime?: number) {
    if (useCache) {
      if (!this.searchData$) {
        this.searchData$ = this.searchByPage(undefined, undefined, params)
          .pipe(map(res => res ? res['data'] : []), shareReplay(1))
      }
      setTimeout(() => {
        this.searchData$ = null;
      }, cacheTime ? cacheTime : 30000);
      return this.searchData$;
    } else {
      return this.searchByPage(undefined, undefined, params)
        .pipe(map(res => res ? res['data'] : []))
    }
  }

  getCurrentSubSystemData() {
    return this.cachedFullData;
  }

  getFullData(useCache?: boolean, cacheTime?: number) {
    // if (useCache) {
    //   if (!this.fullData$) {
    //     this.fullData$ = this.http.get(this.httpBase + this.modelPath).pipe(
    //         map(res => {
    //           return res['data']
    //         }),
    //         shareReplay(1)
    //     );
    //   }
    //   setTimeout(() => {
    //     this.fullData$ = null;
    //   }, cacheTime ? cacheTime : 30000);
    //   return this.fullData$;
    // } else {
    //   return this.http.get(this.httpBase + this.modelPath).pipe(map(res => res['data']));
    // }

    return this.cachedFullData;
  }

  getDataByPage(pageNumber: number, pageSize?: number) {
    const params = {
      pageNumber: pageNumber ? pageNumber.toString() : '1',
      pageSize: pageSize ? pageSize.toString() : '10',
    }
    return this.http.get(this.httpBase + this.modelPath, {params: params}).pipe(map(res => res['data']));
  }

  getDataByPage2(pageNumber?: number, pageSize?: number, additionalParams?: any, orderProperty?, orderType?: 'ASC' | 'DESC'): Observable<any> {
    const params = {
      pageNumber: pageNumber ? pageNumber.toString() : '1',
      pageSize: pageSize ? pageSize.toString() : '0'
    }
    if (orderProperty) {
      params['orderProperty'] = orderProperty;

      if (orderType) {
        params['orderType'] = orderType;
      }
    }

    if (additionalParams) {
      const keys = Object.keys(additionalParams);
      keys.forEach(key => {
        params[key] =  additionalParams[key];
      })
    }

    return this.http.get(this.httpBase + this.modelPath, {params: params});
  }
  
  getDataById(id) {
    return this.http.get(this.httpBase + this.modelPath + '/' + id).pipe(map(res => res['data']));
  }

  getById(id: number) {
    return this.http.get(this.httpBase + this.modelPath + '/' + id).pipe(map(res => res['data']));
  }

  save(obj: Entity, primaryKeyName?: string) {
    this.clearCache();
    if (primaryKeyName) {
      if (!obj[primaryKeyName]) {
        return this.http.post(this.httpBase + this.modelPath, obj);
      } else {
        return this.http.put(this.httpBase + this.modelPath, obj);
      }
    } else {
      if (!obj['id']) {
        return this.http.post(this.httpBase + this.modelPath, obj);
      } else {
        return this.http.put(this.httpBase + this.modelPath, obj);
      }
    }
  }

  searchByIds(ids: any[], primaryKeyName?: string) {
    const params = {};
    if (primaryKeyName) {
      params[primaryKeyName] = ids;
    } else {
      params['ids'] = ids;
    }
    return this.http.get(this.httpBase + this.modelPath + '/list', {params: params}).pipe(map(res => res['data']));
  }

  insertReturning(obj: Entity) {
    this.clearCache();
    return this.http.post(this.httpBase + this.modelPath + '/insertReturning', obj);
  }

  insertMany(objList: Entity[]) {
    this.clearCache();
    return this.http.post(this.httpBase + this.modelPath + '/batchInsert', objList);
  }
  batchUpdate(objList: Entity[]) {
    this.clearCache();
    return this.http.post(this.httpBase + this.modelPath + '/batchUpdate', objList);
  }
  deleteMany(ids) {
    this.clearCache();
    return this.http.post(this.httpBase + this.modelPath + '/batchDelete', ids);
  }

  remove(obj: Entity, primaryKeyName?: string) {
    this.clearCache();
    return this.http.delete(this.httpBase + this.modelPath + '/' + (primaryKeyName ? obj[primaryKeyName] : obj['id']));
  }

  searchByCondition(url, condition?) {
    return this.http.post(this.httpBase + url + '/search', condition ? condition : {}).pipe(map(res => res['data'] ? res['data'] : []));
  }

}
